import { useLocale } from "@/lib/i18n/LocaleContext";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CookieConsentBanner } from "@/components/consent/CookieConsentBanner";
import { extractLocaleFromPath } from "@/lib/i18n/localize-path";

function RouteFallback() {
  const { t } = useLocale();
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      {/* <output> carries an implicit role="status", i.e. a polite live region — but a live
          region's *name* is not announced, only its content. The visible spinner is a CSS border
          with no text, so an aria-label alone told a screen reader nothing. The sr-only span is
          what actually gets read. It also has to be translated: this renders on all six locales. */}
      <output className="block size-8 animate-spin rounded-full border-4 border-border border-t-primary">
        <span className="sr-only">{t("common.loading")}</span>
      </output>
    </div>
  );
}

export function Layout() {
  const location = useLocation();
  const { path } = extractLocaleFromPath(location.pathname);
  const isMapPage = path === "/map" || path === "/locations/map";

  return (
    <div className="min-h-screen bg-background overflow-x-hidden flex flex-col">
      {!isMapPage && <Header />}
      <main className="flex-1">
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </main>
      {!isMapPage && <Footer />}
      <CookieConsentBanner />
    </div>
  );
}
